import { fetchSearchProductData } from "../api/searchProduct.api";
import { useQuery } from "@tanstack/react-query";
import { useShallow } from "zustand/shallow";
import { useUIStore } from "../stores/ui-store";
import { UIState } from "../types/ui-types";

const useSearchProducts = ({
  page,
  companyId,
  limit,
  searchStrings,
  sortBy,
  asc,
}: {
  page?: number;
  companyId: number;
  limit?: number;
  searchStrings?: string[];
  sortBy?: string;
  asc?: boolean;
}) => {
  const [bearerToken] = useUIStore(
    useShallow((state: UIState) => [state.bearerToken]),
  );

  const {
    data: searchProductsData,
    error: searchProductError,
    isLoading: isLoadingSearchProduct,
    isSuccess: isSearchProductSuccess,
    refetch: refetchSearchProducts,
  } = useQuery({
    queryKey: ["searchProducts", companyId, page, searchStrings, sortBy, asc],
    queryFn: () =>
      fetchSearchProductData(
        bearerToken as string,
        companyId,
        false,
        page,
        searchStrings,
        limit,
        false,
        sortBy,
        asc,
      ),
    enabled: !!companyId && !!bearerToken,
  });

  return {
    searchProductsData,
    isLoadingSearchProduct,
    searchProductError,
    isSearchProductSuccess,
    refetchSearchProducts,
  };
};

export default useSearchProducts;
